import React from "react";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { CHAT_MARKDOWN_OVERRIDES } from "containers/ChatGPT/reducer";
import styles from "./style.module.css";
import { Button } from "aible";
import * as projectReducer from "containers/Project/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as deployReducer from "containers/Deployments/reducer";
import * as viewReducer from "containers/View/reducer";
import WarningIcon from "images/warning.svg";
import MarkdownPanel from "components/ChatGPT/MarkdownPanel";
import TinyBarChart from "components/Project/TinyBarChart";
import numeral from "numeral";
import { useDispatch, useSelector } from "@/types/store";
const OptimizeStrategyCard = ({ strategy, selectedStrategy, hoverStrategy, hoverLeave, hoverClick, strategyIndex, originalStrategyMetrics, unitLabel, isCurrencyUnit, descriptionType, mSubgroupData, hStrategy }) => {
    const dispatch = useDispatch();
    const isActiveStrategy = selectedStrategy === strategyIndex || (strategyIndex === -1 && selectedStrategy === undefined);
    // Using $ as unitLabel fallback like logic in projectReducer unitLabel.
    const totalCost = strategy?.metrics?.totalCost ?? 0;
    const totalCostFormatted = `${totalCost > 0 ? "+" : "-"} ${unitLabel ?? "$"}${numeral(Math.abs(totalCost)).format("0.0a")}`;
    const currentSpend = originalStrategyMetrics?.currentSpend;
    const revenue = strategy?.metrics?.revenue ?? 0;
    const revenueFormatted = `${revenue > 0 ? "+" : "-"} ${unitLabel ?? "$"}${numeral(Math.abs(revenue)).format("0.0a")}`;
    const currentRevenue = originalStrategyMetrics?.currentRevenue;
    const profit = strategy?.metrics?.profit ?? 0;
    const profitFormatted = `${profit > 0 ? "+" : "-"} ${unitLabel ?? "$"}${numeral(Math.abs(profit)).format("0.0a")}`;
    const currentProfit = originalStrategyMetrics?.currentProfit;
    const costDelta = totalCost && currentSpend && !isNaN(Number(totalCost)) && !isNaN(Number(currentSpend))
        ? totalCost - currentSpend
        : 0;
    const costDeltaFormatted = `${costDelta > 0 ? "+" : "-"} ${unitLabel ?? "$"}${numeral(Math.abs(costDelta)).format("0.0a")}`;
    const revenueDelta = revenue && currentRevenue && !isNaN(Number(revenue)) && !isNaN(Number(currentRevenue))
        ? revenue - currentRevenue
        : 0;
    const revenueDeltaFormatted = `${revenueDelta > 0 ? "+" : "-"} ${unitLabel ?? "$"}${numeral(Math.abs(Math.round(revenueDelta))).format("0.0a")}`;
    const profitDelta = profit && currentProfit && !isNaN(Number(profit)) && !isNaN(Number(currentProfit)) ? profit - currentProfit : 0;
    const profitDeltaFormatted = `${profitDelta > 0 ? "+" : "-"} ${unitLabel ?? "$"}${numeral(Math.abs(profitDelta)).format("0.0a")}`;
    let retDescription = strategy?.text;
    if (descriptionType === "ABSOLUTE" && strategy?.absoluteText) {
        retDescription = strategy.absoluteText;
    }
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const projectId = useSelector((state) => nextReducer.getProjectId(state, nextId));
    const deployedScenarioIndex = useSelector((state) => projectReducer.getDeployedScenarioIndex(state, projectId));
    const deployment = useSelector((state) => deployReducer.getProjectDeployment(state, projectId));
    const projectMonitor = useSelector((state) => projectReducer.getProjectMonitor(state, projectId));
    const hasSame = useSelector((state) => projectReducer.getHasSameScenario(state, projectId, false, true));
    const project = useSelector((state) => projectReducer.getProject(state, projectId));
    const allScenarios = useSelector((state) => projectReducer.getAllScenarios(state, projectId));
    const deployedScenario = allScenarios?.[deployedScenarioIndex];
    const isDeployed = strategy.title === deployedScenario?.originalScenario?.name ||
        (strategyIndex === -1 && deployedScenario?.originalScenario?.name === "New Deployed Scenario");
    const linkedProjectId = useSelector((state) => projectReducer.getLinkedProjectId(state, projectId));
    const reports = useSelector((state) => viewReducer.getReports(state));
    const linkedReport = reports.find((r) => linkedProjectId !== undefined && r?.metadata?.explorations?.[0]?.projectId === linkedProjectId);
    const targetSubGroups = mSubgroupData !== undefined ? mSubgroupData?.filter((mGroup) => mGroup?.label !== "Overall") : undefined;
    const warningRecommendation = useSelector((state) => projectReducer.getCheckBalance(state, projectId));
    const showBalancerSettings = useSelector((state) => chatGPTReducer.getShowBalancerSettings(state));
    //const warningRecommendation = checkBalance(targetSubGroups);
    return (React.createElement("div", { className: isActiveStrategy
            ? styles.optimizeStrategyCard + " " + styles.optimizeStrategyCardActive
            : styles.optimizeStrategyCard, onMouseEnter: (e) => {
            hoverStrategy(strategy.strategy);
        }, onMouseLeave: (e) => hoverLeave(), onClick: (e) => {
            if (showBalancerSettings) {
                dispatch(chatGPTReducer.updateShowBalancerSettings(false));
            }
            hoverClick(strategyIndex);
        } },
        React.createElement(MarkdownPanel, { overrides: CHAT_MARKDOWN_OVERRIDES }, retDescription),
        React.createElement("div", { className: styles.optimizeCardMetricsContainer },
            React.createElement("div", { className: styles.optimizeCardMetricItem },
                React.createElement("div", { className: styles.optimizeCardMetricLabel }, originalStrategyMetrics?.costLabel),
                React.createElement("div", { className: styles.optimizeCardMetricDeltaValue }, descriptionType === "ABSOLUTE" ? totalCostFormatted : costDeltaFormatted),
                React.createElement("div", { className: styles.optimizeStrategyCardBar },
                    React.createElement(TinyBarChart, { bars: [
                            {
                                label: "Optimal " + originalStrategyMetrics?.costLabel,
                                Cost: totalCost
                            },
                            {
                                label: "Baseline " + originalStrategyMetrics?.costLabel,
                                Cost: currentSpend
                            }
                        ], unit: unitLabel, isCurrencyUnit: isCurrencyUnit, hideText: true, 
                        //hideTooltip
                        barChartHeight: 20, noMargin: true }))),
            React.createElement("div", { className: styles.optimizeCardMetricItem },
                React.createElement("div", { className: styles.optimizeCardMetricLabel }, originalStrategyMetrics?.revenueLabel),
                React.createElement("div", { className: styles.optimizeCardMetricDeltaValue }, descriptionType === "ABSOLUTE" ? revenueFormatted : revenueDeltaFormatted),
                React.createElement("div", { className: styles.optimizeStrategyCardBar },
                    React.createElement(TinyBarChart, { bars: [
                            {
                                label: "Optimal " + originalStrategyMetrics?.revenueLabel,
                                Cost: revenue
                            },
                            {
                                label: "Baseline " + originalStrategyMetrics?.revenueLabel,
                                Cost: currentRevenue
                            }
                        ], unit: unitLabel, isCurrencyUnit: isCurrencyUnit, hideText: true, 
                        //hideTooltip
                        barChartHeight: 20, noMargin: true }))),
            React.createElement("div", { className: styles.optimizeCardMetricItem },
                React.createElement("div", { className: styles.optimizeCardMetricLabel }, originalStrategyMetrics?.profitLabel),
                React.createElement("div", { className: styles.optimizeCardMetricDeltaValue }, descriptionType === "ABSOLUTE" ? profitFormatted : profitDeltaFormatted),
                React.createElement("div", { className: styles.optimizeStrategyCardBar },
                    React.createElement(TinyBarChart, { bars: [
                            {
                                label: "Optimal " + originalStrategyMetrics?.profitLabel,
                                Cost: profit
                            },
                            {
                                label: "Baseline " + originalStrategyMetrics?.profitLabel,
                                Cost: currentProfit
                            }
                        ], unit: unitLabel, isCurrencyUnit: isCurrencyUnit, hideText: true, 
                        //hideTooltip
                        barChartHeight: 20, noMargin: true })))),
        isActiveStrategy && (React.createElement("div", { className: styles.deployActions },
            isDeployed === true ? (React.createElement("div", null)) : (React.createElement(Button, { onClick: async (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    await dispatch(projectReducer.deploy(projectId, undefined, strategyIndex === -1));
                }, type: "primary" }, "Deploy")),
            warningRecommendation !== undefined && selectedStrategy === strategyIndex && (React.createElement("div", { className: styles.scenarioWarningWrapper },
                React.createElement("div", { className: styles.scenarioWarningIconWrapper },
                    React.createElement("img", { src: WarningIcon })),
                React.createElement("div", null, `Based on this scenario we recommend increasing ${warningRecommendation?.highestSubgroup?.label} marketing by ${Math.round(warningRecommendation.percentChange)}%`),
                linkedReport !== undefined && (React.createElement(Button, { style: { marginLeft: "20px" }, onClick: () => window.open("/next/" + linkedReport?.metadata?.explorations?.[0]?.datasetId + "/" + linkedReport?.id) }, "View Marketing")),
                React.createElement(Button, { style: { marginLeft: "20px" }, onClick: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        dispatch(projectReducer.applyBoost(projectId, linkedProjectId));
                    } }, "Increase Marketing"),
                React.createElement(Button, { style: { marginLeft: "20px" }, onClick: () => {
                        dispatch(chatGPTReducer.updateShowBalancerSettings(!showBalancerSettings));
                    } }, showBalancerSettings ? "Hide Balance Settings" : "Rebalance Marketing"))))),
        isDeployed && React.createElement("div", { className: styles.deployActions }, "Model Deployed")));
};
export default OptimizeStrategyCard;
